import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

const isIPhoneWithNotch = PlatformUtils.isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  QAheader: {
    marginTop: 16,
    marginHorizontal: 0,
  },
  QAcontainer: {
    flex: 1,
    alignItems: 'flex-start',
  },
  QAicon: {
    marginTop: 13,
  },
  QAtitle: {
    fontSize: 25,
    letterSpacing: -0.31,
    marginTop: 17,
    lineHeight: 31.2,
    fontFamily: Fonts.type.VodafoneLt,
  },
  QAbutton: {
    width: '100%',
    marginBottom: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 20 : 15) : 30,
  },
});
